<template>
    <div class="trainsCostQuery-box">
        <HeaderNav
            header-title="趟数查询"
            left-icon-name="2"
            right-icon-name="3"
        ></HeaderNav>
        <van-tabs v-model="active" sticky @click="clickTab">
            <van-tab
                :title="item.name"
                v-for="(item, index) in tabs"
                :key="index"
            >
            </van-tab>
            <div class="time-select-con" v-if="active==4">
                <div class="time-select">
                    <span class="iconfont iconshijian"></span>
                    <span class="time" @click="chooseDate(0)">{{ queryDate[0] || '开始日期' }}</span>
                    <span class="split-line"></span>
                    <span class="iconfont iconshijian"></span>
                    <span class="time" @click="chooseDate(1)">{{ queryDate[1] || '结束日期' }}</span>
                </div>
            </div>
            <div class="tab-con">
                <div class="header-tag">
                    <div class="item">
                        <h4>
                            <span class="iconfont iconjiaobanche"></span>
                            <span>累计车次(趟)</span>
                        </h4>
                        <div class="color-tag color1">
                            {{ total.count }}
                        </div>
                    </div>
                    <div class="item">
                        <h4>
                            <span class="iconfont icontijikongjian"></span>
                            <span>累计方量(m³)</span>
                        </h4>
                        <div class="color-tag color2">
                            {{ total.volumn }}
                        </div>
                    </div>
                    <div class="item">
                        <h4>
                            <span class="iconfont iconlicheng"></span>
                            <span>累计公里(km)</span>
                        </h4>
                        <div class="color-tag color3">
                            {{ total.distance }}
                        </div>
                    </div>
                </div>
                <div class="list-con">
                    <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="onLoad"
                        :immediate-check="false"
                    >
                        <div class="list-item" v-for="item in list" :key="item.pcb_number">
                            <h4>
                                <span class="iconfont icondanjubianhao"></span>
                                <span class="tit">运输单号：{{ item.pcb_number }}</span>
                            </h4>
                            <ul>
                                <li>
                                    <span class="icon icon1"></span>
                                    <label>车号：</label>
                                    <span class="info">{{ item.shch }}</span>
                                </li>
                                <li>
                                    <span class="icon icon2"></span>
                                    <label>方量：</label>
                                    <span class="info">{{ item.volume }}m³</span>
                                </li>
                                <li>
                                    <span class="icon icon3"></span>
                                    <label>运距：</label>
                                    <span class="info">{{ item.haul_distance }}</span>
                                </li>
                                <li>
                                    <span class="icon icon4"></span>
                                    <label>场站：</label>
                                    <span class="info">{{ item.mixstation_name }}</span>
                                </li>
                            </ul>
                            <div class="bottom">
                                <div class="item">
                                    调度时间：{{ item.created|timeFormater }}
                                </div>
                                <div class="item">
                                    打料时间：{{ item.product_time|timeFormater }}
                                </div>
                            </div>
                        </div>
                    </van-list>
                </div>
            </div>
            <van-popup v-model="showTimeDatePop" position="bottom" :overlay="true">
                <van-datetime-picker
                    v-model="datetime"
                    type="year-month"
                    title="选择年月"
                    @confirm="confimDate"
                    @cancel="showTimeDatePop = false"
                ></van-datetime-picker>
            </van-popup>
        </van-tabs>
    </div>
</template>

<script>
import { HeaderNav } from '@/components/';
import { Toast } from 'vant';
import Utils from '@/utils/util.js';
export default {
    components: { HeaderNav },
    props: {},
    data() {
        return {
            active: 0,
            tabs: [
                { name: '当天' },
                { name: '当月' },
                { name: '上月' },
                { name: '近三个月' },
                { name: '按日期' },
            ],
            pagetion: {
                pageindex: 1,
                pagesize: 4,
            },
            loading: false,
            finished: false,
            list: [],
            queryType: 0, // 查询条件 0 当天 1当月 2上月 3 近三月
            total: {
                count: 0,
                volumn: 0,
                distance: 0,
            },

            // 时间选择弹框
            showTimeDatePop: false,
            // 弹窗类型 0.开始时间，1结束时间
            timeDatePopIndex: 1,
            datetime: new Date(),
            // 查询日期
            queryDate: ['', ''],
        };
    },
    filters: {
        timeFormater(value) {
            let str = '';
            if (value) {
                const arr = value.split(' ');
                const arr2 = arr[1].split(':');
                str = arr[0] + ' ' + arr2[0] + ':' + arr2[1];
            }
            return str;
        },
    },
    watch: {},
    computed: {},
    methods: {
        onLoad() {
            // 异步更新数据
            // setTimeout 仅做示例，真实场景中一般为 ajax 请求
            setTimeout(() => {
                this.pagetion.pageindex += 1;
                this.getDetail();
            }, 1000);
        },
        // 获取统计信息
        getTotal() {
            this.$axios
                .get('/interfaceApi/production/productpcb/get_total/' + this.queryType
                    + '?beginTime=' + this.queryDate[0] + '&endTime=' + this.queryDate[1])
                .then(res => {
                    if (res) {
                        this.total = res;
                    }
                })
                .catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
        // 获取司机运输单统计
        getDetail() {
            const queryStr = '?type=' + this.queryType + '&pageindex=' + this.pagetion.pageindex + '&pagesize=' + this.pagetion.pagesize
            + '&beginTime=' + this.queryDate[0] + '&endTime=' + this.queryDate[1];
            this.$axios
                .get('/interfaceApi/production/productpcb/get_detail' + queryStr)
                .then(res => {
                    if (res) {
                        if (res.total) {
                            this.list = this.list.concat(res.rows);
                            if (Number(this.list.length) >= res.total) {
                                this.finished = true;
                            } else if (Number(this.list.length) === 0) {
                                this.finished = true;
                            } else {
                                this.finished = false;
                                this.loading = false;
                            }
                        } else {
                            this.finished = true;
                        }
                    }
                })
                .catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
        // 切换页面查询
        clickTab(name) {
            this.list = [];
            this.queryType = name;
            this.pagetion.pageindex = 1;
            if (name !== 4) {
                this.queryDate = ['', ''];
                this.getTotal();
                this.getDetail();
            }
        },

        // 选择时间
        chooseDate(index) {
            this.timeDatePopIndex = index;
            if (this.queryDate[index]) {
                this.datetime = new Date(this.queryDate[index]);
            }
            this.showTimeDatePop = true;
        },
        // 确认选择时间
        confimDate(val) {
            this.queryDate[this.timeDatePopIndex] = Utils.timeFormat(val, 'yyyy-MM-dd');
            this.showTimeDatePop = false;
            this.getTotal();
            this.getDetail();
        },
    },
    created() {
        this.getTotal();
        this.getDetail();
    },
    mounted() {},
};
</script>
<style lang="stylus">
.trainsCostQuery-box
    padding-top 44rpx
    height calc(100% - 44rpx)
    .van-tabs
        height 100%
        .van-tabs__content
            height calc(100% - 44rpx)
            background #F0F0F0
            .van-tab__pane
                height 0
            .tab-con
                height 100%
                padding 10rpx
                .header-tag
                    background-color #FFFFFF
                    border-radius 4rpx
                    height 80rpx
                    margin-bottom 15rpx
                    .item
                        padding 10rpx
                        float left
                        width calc(100% / 3)
                        h4
                            font-size 13rpx
                            color #979EA7
                            .iconfont
                                font-size 14rpx
                                margin-right 2rpx
                                &:before
                                    transform rotate(90deg)
                        .color-tag
                            width 100%
                            height 40rpx
                            font-size 18rpx
                            line-height 40rpx
                            margin-top 5rpx
                            text-align center
                            white-space nowrap
                            overflow hidden
                            text-overflow ellipsis
                            &.color1
                                background-color rgba(52,149,250,0.06)
                                color #3495FB
                            &.color2
                                background-color rgba(241,86,68,0.06)
                                color #F15644
                            &.color3
                                background-color rgba(23,188,132,0.06)
                                color #17BC84
                .list-con
                    height calc(100% - 90rpx)
                    overflow-y auto
                    overflow-x hidden
                    .list-item
                        background #ffffff
                        border-radius 4rpx
                        margin-bottom 15rpx
                        h4
                            background-color #FAFAFA
                            border-bottom 1px solid #F0F0F0
                            height 40rpx
                            line-height 40rpx
                            padding-left 10rpx
                            .icondanjubianhao
                                font-size 16rpx
                                color #3495FB
                                margin-right 5rpx
                            .tit
                                font-size 16rpx
                        ul
                            padding 10rpx
                            border-bottom 1px solid #F0F0F0
                            overflow hidden
                            li
                                float left
                                width 50%
                                line-height 32rpx
                                .icon
                                    width 18rpx
                                    height 18rpx
                                    display inline-block
                                    vertical-align middle
                                    margin-right 5rpx
                                    line-height 18rpx
                                    &:before
                                        content ' '
                                        width 16rpx
                                        height 16rpx
                                        display inline-block
                                        background-repeat no-repeat
                                        background-size 100% 100%
                                    &.icon1
                                        &:before
                                            background-image url(./../../../assets/images/icons/icon_18.png)
                                    &.icon2
                                        &:before
                                            background-image url(./../../../assets/images/icons/icon_30.png)
                                    &.icon3
                                        &:before
                                            background-image url(./../../../assets/images/icons/icon_26.png)
                                    &.icon4
                                        &:before
                                            background-image url(./../../../assets/images/icons/icon_gy_2.png)
                                label
                                    font-size 14rpx
                                .info
                                    font-size 14rpx
                                    color #979EA7
                        .bottom
                            display flex
                            justify-content space-between
                            .item
                                flex 1
                                padding-left 5rpx
                                font-size 10rpx
                                color #979EA7
                                line-height 30rpx
                                &:last-child
                                    text-align right
                                    padding-right 5rpx
            .time-select-con
                padding 15rpx 15rpx 8rpx 15rpx
            .time-select
                background #fff
                box-shadow 2px 2px 8px rgba(84, 148, 243, 0.2)
                border-radius 4rpx
                border 1px solid #D7D7D7
                height 36rpx
                line-height 36rpx
                display flex
                justify-content center
                .split-line
                    width 10rpx
                    background-color #979EA7
                    height 1px
                    display inline-block
                    margin 18rpx 5rpx 0 5rpx
                .time
                    display inline-block
                    width 80rpx
                    font-size 13rpx
                .iconshijian
                    color #979EA7
                    margin 0 6rpx
                    font-size 14rpx
</style>
